"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useControlledInterceptor = void 0;

var _react = _interopRequireDefault(require("react"));

var _interceptor = require("./interceptor");

var _router = require("./router");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/**
 * This is a controlled version of the interceptor which cancels any navigation intent
 * and hands control over it to your calling component.
 *
 * `interceptedPath` is initially `null` and will be set to the target path upon navigation.
 * `confirmNavigation` is the callback to be called to stop the interception and navigate to the last path.
 * `resetPath` is a callback that resets `interceptedPath` back to `null`.
 *
 * @returns {Array} [interceptedPath, confirmNavigation, resetPath]
 */


var useControlledInterceptor = function useControlledInterceptor() {
  var _React$useState = _react.default.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      interceptedPath = _React$useState2[0],
      setInterceptedPath = _React$useState2[1];

  var interceptorFunction = _react.default.useMemo(function () {
    return function (currentPath, nextPath) {
      setInterceptedPath(nextPath);
      return currentPath;
    };
  }, [setInterceptedPath]);

  var stopInterception = (0, _interceptor.useInterceptor)(interceptorFunction);

  var confirmNavigation = _react.default.useMemo(function () {
    return function () {
      stopInterception();
      (0, _router.navigate)(interceptedPath);
    };
  }, [stopInterception, interceptedPath]);

  var resetPath = _react.default.useMemo(function () {
    return function () {
      return setInterceptedPath(null);
    };
  }, [setInterceptedPath]);

  return [interceptedPath, confirmNavigation, resetPath, stopInterception];
};

exports.useControlledInterceptor = useControlledInterceptor;